import { render, staticRenderFns } from "./ItemClassification.vue?vue&type=template&id=4ef1afbf&scoped=true&"
import script from "./ItemClassification.vue?vue&type=script&lang=js&"
export * from "./ItemClassification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ef1afbf",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
